import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import getTitle from "../../../../helpers/getTitle";
import classNames from "classnames";
import {renderIf, renderIfElse} from "../../../Shared";
import _ from "lodash";
import {formatDate, renderFromToTime} from "../../../../helpers/datetimeHelpers";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";

export const renderSubjectResultItem = ({renderActions = NullAsDefault} = {}) => (item, index) => {

    const {subject, course_class, result_date, result_status, notes, score_type, score_text, score_number} = item ?? {}

    let label_status
    let color_status
    switch (result_status) {
        case 1:
            label_status = 'passed'
            color_status = 'text-green-600'
            break
        case 0:
            label_status = 'failed'
            color_status = 'text-red-600'
            break
        default:
            label_status = 'not assessed yet'
            color_status = 'text-color-300'
            break
    }

    return (
        <LayoutContext.Consumer>
            {({isSm}) => (
                <Translate key={index}>
                    {(t) => (
                        <div className="flex flex-col gap-1 border border-color-50 rounded-md relative p-2">
                            <div className="font-bold text-sm text-color-000">
                                {getTitle(subject)}
                            </div>
                            <div className="grid grid-cols-2 gap-1">
                                {renderIf(
                                    _.some([score_text, score_number > 0]),
                                    <div className="space-x-1 text-xs italic">
                                        <span className="text-color-400">{`${t('score')} : `}</span>
                                        <span className="font-medium text-color-100">
                                        {renderIfElse(
                                            score_type === 'text',
                                            score_text,
                                            score_number
                                        )}
                                    </span>
                                    </div>
                                )}
                                <div className="space-x-1 text-xs italic">
                                    <span className="text-color-500">
                                        {`${t('result date')} : `}
                                    </span>
                                    <span className="font-medium text-color-100">
                                        {formatDate(result_date, 'DD/MM/YYYY')}
                                    </span>
                                </div>
                            </div>
                            <span className="space-x-1 text-xs text-color-400 italic">
                            <span>{t('learn in the class')}</span>
                            <span className="font-bold text-color-100">
                                {getTitle(course_class)}
                            </span>
                            <span>{t('in the course')}</span>
                            <span className="font-bold text-color-000">
                                {getTitle(course_class?.course)}
                            </span>
                            <span className="font-medium text-color-300 lowercase">
                                ({renderFromToTime(course_class?.from_date, course_class?.to_date)})
                            </span>
                        </span>
                            {renderIf(
                                notes,
                                <span className="space-x-1 text-xs italic">
                                <span className="font-bold text-color-100">{`* ${t('note')} : `}</span>
                                <span className="text-color-300">{notes}</span>
                            </span>
                            )}
                            {renderIf(
                                result_status !== null,
                                <span
                                    style={{position: 'absolute', top: 10, right: 10}}
                                    className={
                                        classNames(
                                            'font-bold text-xs tracking-wide uppercase opacity-75',
                                            color_status
                                        )
                                    }>
                                {t(label_status)}
                            </span>
                            )}
                            {renderActions(item)}
                        </div>
                    )}
                </Translate>
            )}
        </LayoutContext.Consumer>
    )
}
